export const PASSWORD_RESET_FORM_SUBMITTED = "PASSWORD_RESET_FORM_SUBMITTED"
export const passwordResetFormSubmitted = (email: string, token: string, newPassword: string) => ({
    type: PASSWORD_RESET_FORM_SUBMITTED,
    payload: {
        email: email,
        token: token,
        newPassword: newPassword,
    },
})

export const PASSWORD_RESET_REQUESTED = "PASSWORD_RESET_REQUESTED"
export const passwordResetRequested = (email: string, token: string, newPassword: string) => ({
    type: PASSWORD_RESET_REQUESTED,
    payload: {
        email: email,
        token: token,
        newPassword: newPassword,
    },
})

export const PASSWORD_RESET_SUCCESS = "PASSWORD_RESET_SUCCESS"
export const passwordResetSuccess = () => ({
    type: PASSWORD_RESET_SUCCESS,
})

export const PASSWORD_RESET_FAILURE = "PASSWORD_RESET_FAILURE"
export const passwordResetFailure = (error: any) => ({
    type: PASSWORD_RESET_FAILURE,
    payload: {
        error: error,
    },
})
